import React, { useEffect, useState } from 'react'
import Carousal from '../Page-component/Carousal';
import Featured from '../Page-component/Featured';
import { Key_Features, subTopic } from '../Helper/Usabledata';
import { VscTriangleRight } from "react-icons/vsc";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { TiSocialFacebookCircular } from "react-icons/ti";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosCall } from "react-icons/io";
import { IoNavigateCircleOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import { MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";
import { CiFacebook } from "react-icons/ci";
import { FaInstagram } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { fetchTeacher } from '../Firebase/User-fb';
import userProfile from '../Images/Logo/default-profile.png'
import { useAccessCard } from '../ContextProvider/Accesscardprovider';
import StickySocials from './StickySocials';

const Homedashboard = () => {

  const navigate = useNavigate();
  const [teacher, setTeacher] = useState([])

  const subTopicNavigate = (url) => {
    navigate(url);
  }

  useEffect(() => {
    const getTeacher = async () => {
      try {
        const expert = await fetchTeacher();
        const sortedExpert = expert.sort((a, b) => a.displayPriority - b.displayPriority);
        setTeacher(sortedExpert);
      } catch (error) {
        console.error("Failed to fetch teacher:", error);
      }
    };

    getTeacher();
  }, []);


  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div>
      <div id='home-section'>
        <Carousal />
      </div>

      <div className='sub-topic'>
        <div className='sub-topic_container'>
          {subTopic.map((item) => (
            <div className='sub-topic_card' onClick={() => subTopicNavigate(item.url)}>
              <img src={item.src} />
              <h3>{item.name}</h3>
            </div>
          ))}
        </div>
      </div>

      <div id="featured-section">
        <Featured />
      </div>


      <div id='expert-section'>
        <div className='expert_container'>
          <h2>Experts<span>:-</span></h2>
          <Slider {...settings}>
            {teacher.map((item) => (
              <div className='expert_card'>
                <img src={item.image} />
                <h3>{item.name}</h3>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className='about-section' id='about-section'>
        <h2 style={{fontSize:"23px"}}>About B_BARNA Education Institute</h2>
        <div className="about-container">
          <h1 className='about-head'>Welcome to <span>B_Barna</span></h1>
          <p>B_Barna is an educational platform that provides quality learning resources for students. We offer online courses, live classes, and other educational materials.</p>

          <h2 className='about-head'>Our Mission</h2>
          <p>Our mission is to create easy and effective learning opportunities for students. We aim to make education more accessible and engaging through technology.</p>

          <h2 className='about-head'>Our Vision</h2>
          <p>We believe education should be accessible and high-quality for everyone. Our platform helps students gain skills and prepare for the future.</p>

          <h2 className='about-head'>Who We Are</h2>
          <p>We are a dedicated team of educators, technologists, and visionaries united by a common goal: to revolutionize education in India.</p>

          <h2 className='about-head'>Why Choose Us?</h2>
          <ul>
            <li>High-quality and updated educational content</li>
            <li>User-friendly platform.</li>
            <li>Special support and guidance for students.</li>
          </ul>

          <h2 className='about-head'>Our Commitment to Excellence</h2>
          <p>Quality is the cornerstone of our platform. We collaborate with renowned educators, institutions, and industry experts to curate content that is accurate, up-to-date, and aligned with industry standards.</p>

          <h2 className='about-head'>How We Empower Learners</h2>
          <ul>
            <li><strong>Affordability and Accessibility:</strong> Education should be affordable and accessible to all.</li>
            <li><strong>Inclusivity:</strong> We celebrate diversity and cater to learners from diverse backgrounds across India.</li>
            <li><strong>Community Engagement:</strong> Join a vibrant community of learners and collaborate with peers to enhance your learning journey.</li>
          </ul>
          <div>
            <div className='contactus-container'>
              <h3>Contact Us</h3>
              <div className="contact-us-box">
                <div className="contact-row">
                  <FaLocationDot className="contact-label" />
                  <div className="contact-info"> Basirhat, north 24 parganas, West Bengal, 743427, India. </div>
                </div> <div className="contact-row">
                  <IoIosCall className="contact-label" />
                  <div className="contact-info">+91-7001739646</div>
                </div> <div className="contact-row">
                  <MdEmail className="contact-label" />
                  <div className="contact-info">bbarna.official@gmail.com</div>
                </div>
              </div>
              <div className="social-icons">
                <a href="https://wa.me/917001739646" target="_blank" rel="noopener noreferrer" className="nav-social-link">
                  <FaWhatsapp className='contactus-icon' />
                </a>
                <a href="https://www.facebook.com/share/15awFXTt6E/" rel="noopener noreferrer" target="_blank" className="nav-social-link">
                  <CiFacebook className='contactus-icon extras' />
                </a>
                <a href="https://t.me/IAS2893" target="_blank" rel="noopener noreferrer" className="nav-social-link">
                  <IoNavigateCircleOutline className="contactus-icon extras" />
                </a>

                <a href='https://www.youtube.com/@BBarnaEdu' target="_blank" rel="noopener noreferrer" className="nav-social-link">
                  <AiOutlineYoutube className='contactus-icon extra' />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <StickySocials />

    </div>
  )
}

export default Homedashboard